export { default } from "./Barchart";
